// services/api.js
export const fetchWithAuth = async (url, options = {}) => {
  const token = sessionStorage.getItem('jwt_token'); // ⬅ byt från sessionStorage

  const headers = {
    ...(token && { 'Authorization': `Bearer ${token}` }),
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    sessionStorage.clear(); // enklare, töm hela sessionen
    window.location.href = '/';
  }

  return response;
};

export const uploadWithAuth = async (url, formData) => {
  const token = sessionStorage.getItem('jwt_token'); // ⬅ byt här också

  const headers = {
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (response.status === 401) {
    sessionStorage.clear();
    window.location.href = '/';
  }

  return response;
};


export const getUserInfoById = async (userId) => {
  try {
    let url = '/api/admin/users/details';
    if (userId) {
      url += `?userId=${userId}`;
    }
    const response = await fetchWithAuth(url);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Kunde inte hämta användare');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Failed to fetch user ${userId}:`, error);
    return null; // ← VIKTIGT: Returnera null istället för inget
  }
}